module.exports = __webpack_public_path__ + "static/media/2h.c3ec5427.jpg";